import { Component, Input, OnInit, inject, input, output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { ItemForm } from 'src/app/models/item-form.model';
import { Stakeholder } from 'src/app/models/stakeholder.model';
import { ItemCategory } from 'src/app/models/item-category';
import { translateItemCategory } from 'src/app/utils/item.util';
import { NgClass } from '@angular/common';
import { CustomIconComponent } from '../../../../shared-modules/custom-icon/custom-icon.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';




@Component({
    selector: 'app-assign-items-form',
    templateUrl: './assign-items-form.component.html',
    styleUrls: ['./assign-items-form.component.scss'],
    imports: [CustomIconComponent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatCheckbox, ReactiveFormsModule, NgClass, MatIcon, MatFormField, MatInput, MatSelect, MatOption, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton]
})
export class AssignItemsFormComponent implements OnInit {
  private formBuilder = inject(FormBuilder);


  public dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  public displayedColumns: string[] = ['name', 'stakeholder'];
  public selectedOption: any;
  public itemCategory: typeof ItemCategory = ItemCategory;

  private items!: FormArray;

  @Input() itemForm!: ItemForm;
  readonly stakeholders = input<Stakeholder[]>([]);
  readonly initiator = input<any>({} satisfies Record<string, number>);

  readonly dataUpdated = output<ItemForm>();

  public ngOnInit(): void {
    this.items = this.itemForm.formGroup.get('items') as FormArray;
    this.dataSource.data = this.items.controls;
    this.itemForm.formGroup.valueChanges.subscribe(() => this.dataUpdated.emit(this.itemForm));
  }

  public addInputAllowed(): boolean {
    const isMobility = this.itemForm.itemCategory === ItemCategory.MOBILITY;
    const isPlace = this.itemForm.itemCategory === ItemCategory.PLACE;
    return isMobility || isPlace ? this.items.length < 7 : false;
  }

  public addInput(): void {
    this.items.push(this.getItemFormGroup());
    this.dataSource.data = this.items.controls;
  }

  public removeInput(index: number) {
    this.items.removeAt(index);
    this.dataSource.data = this.items.controls;
  }

  get category() {
    return translateItemCategory(this.itemForm.itemCategory);
  }

  private getItemFormGroup(stakeholder = this.initiator(), active = true): FormGroup {
    const itemGroup = this.formBuilder.group({});
    const defaultItem = {
      name: '',
      stakeholder: stakeholder,
      active: active
    };

    Object.entries(defaultItem).forEach(([key, value]) => {
      const defaultValue = key === 'name' || key === 'active' || key === 'custom' ? value : value.user_id;
      itemGroup.addControl(
        key,
        this.formBuilder.nonNullable.control(defaultValue, { validators: [Validators.required], updateOn: 'blur' })
      );
    });

    return itemGroup;
  }
}
